import { useEffect } from 'react'

type PropTypes = {
  getData: Function
  onValidSession?: Function
  onNoSession?: Function
}

const useSession = ({
  getData,
  onValidSession,
  onNoSession,
}: PropTypes) => {
  // We can rely on RTK Query's caching rather than Redux. It won't
  // refetch unless the cache tag is invalidated or the page is refreshed
  const { data: user, isFetching: isSessionLoading, isSuccess, isError } = getData()

  useEffect(() => {
    if (isSuccess && user) {
      onValidSession?.()
    } else if (isError) {
      onNoSession?.()
    }
  }, [user, isSuccess, isError, onValidSession, onNoSession])

  return { user, isSessionLoading }
}

export default useSession
